import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrochureContainer } from 'shared/containers/NewbuildingBrochure';

import { NewbuildingSpecifications as NewbuildingSpecificationsComponent } from '../../components/NewbuildingSpecifications';
import { getNewbuildingSpecifications, getNewbuildingDeveloper, getNewbuildingStatus } from '../../selectors/newObject';

export interface INewbuildingSpecificationsProps {
  name: string;
}

export const NewbuildingSpecifications: React.FC<INewbuildingSpecificationsProps> = ({ name }) => {
  const specifications = useSelector(getNewbuildingSpecifications);
  const status = useSelector(getNewbuildingStatus);
  const developer = useSelector(getNewbuildingDeveloper);

  return (
    <NewbuildingSpecificationsComponent
      brochure={<NewbuildingBrochureContainer />}
      specifications={specifications}
      developer={developer}
      status={status}
      name={name}
    />
  );
};
